<div class="mat-container users">
  <mat-table
    #table
    class="mat-elevation-z8"
    [dataSource]="dataSourceRoleUsers"
    cdkDropList
    #usersListTable
    #usersList="cdkDropList"
    [cdkDropListData]="dataSourceRoleUsers.data"
    (cdkDropListDropped)="drop($event)"
    id="usersListTable"
  >
    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef> Name </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <button
          mat-icon-button
          *ngIf="dragEnabled && !isOnlyPTC"
          [disabled]="isPendingDelete(element)"
          [ngClass]="{ 'disabled-drag-handle': isPendingDelete(element) }"
        >
          <mat-icon [color]="isPendingDelete(element) ? undefined : 'accent'"
            >reorder</mat-icon
          >
        </button>
        <a
          class="blue bold"
          (click)="navigateToCatalog(element?.userID)"
          [ngClass]="{
            hilite: isUserModified(element),
            'pending-delete-text': showRoleModified && isPendingDelete(element),
          }"
        >
          {{ element.user?.name }}
        </a>
        <mat-icon
          *ngIf="showRoleModified && isPendingDelete(element)"
          color="warn"
          class="pending-change-icon"
          matTooltip="This user is pending to be deleted from the role upon approval"
          >delete</mat-icon
        >
        <mat-icon
          *ngIf="userHasPendingChange(element)"
          color="accent"
          class="pending-change-icon"
          matTooltip="This user has a pending change in the User Catalog"
          >warning</mat-icon
        >
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="notes">
      <mat-header-cell *matHeaderCellDef> Notes </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <label
          *ngFor="let note of element?.notes"
          [ngClass]="{ 'modified-note': isNoteModified(element, note) }"
        >
          {{ note?.description }}
        </label>
      </mat-cell>
    </ng-container>
    <ng-container *ngIf="modifying && !isOnlyPTC" matColumnDef="noteActions">
      <mat-header-cell *matHeaderCellDef> Note actions </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <mat-list>
          <mat-list-item
            style="font-size: 12px"
            *ngFor="let note of element?.notes"
          >
            <button
              mat-icon-button
              *ngIf="modifying && !isPendingDelete(element)"
              (click)="openNoteEditor(element, note)"
            >
              <mat-icon color="accent">edit</mat-icon>
            </button>
            <button
              mat-icon-button
              *ngIf="modifying && !isPendingDelete(element)"
              (click)="deleteNote(element, note)"
            >
              <mat-icon color="warn">delete</mat-icon>
            </button>

            <mat-divider *ngIf="element?.notes?.length > 1"></mat-divider>
          </mat-list-item>
        </mat-list>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="add">
      <mat-header-cell class="mat-column-opt" *matHeaderCellDef>
        <mat-icon
          mat-list-icon
          *ngIf="role?.status"
          class="add fakeA"
          color="accent"
          (click)="openAddRoleUser()"
          >add</mat-icon
        >
        <mat-icon
          mat-list-icon
          *ngIf="!role?.status"
          matTooltip="You can not add users to an inactive role"
          >add</mat-icon
        >
      </mat-header-cell>
      <mat-cell class="mat-column-opt" *matCellDef="let element">
        <div class="cell-container w-100">
          <button
            mat-icon-button
            *ngIf="modifying && hasVisibleMenuActions(element)"
            color="primary"
            [matMenuTriggerFor]="menu"
            aria-label="Schedules menu"
          >
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button
              mat-menu-item
              *ngIf="!isPendingDelete(element) && (element?.notes?.length ?? 0) == 0"
              (click)="openNoteEditor(element)"
            >
              <mat-icon color="accent">edit</mat-icon>
              <span>Add note</span>
            </button>
            <button
              mat-menu-item
              *ngIf="!isPendingDelete(element)"
              (click)="deleteRoleUser(element)"
            >
              <mat-icon color="warn">delete</mat-icon>
              <span>Delete</span>
            </button>
            <button
              mat-menu-item
              *ngIf="isPendingDelete(element) && showRoleModified"
              (click)="undeleteRoleUser(element)"
            >
              <mat-icon color="accent">undo</mat-icon>
              <span>Undo delete</span>
            </button>
          </mat-menu>
        </div>
      </mat-cell>
    </ng-container>
    <mat-header-row
      *matHeaderRowDef="displayedColumnsRoleUsers; sticky: true"
    ></mat-header-row>
    <mat-row
      [cdkDragDisabled]="!dragEnabled || isPendingDelete(row)"
      [ngClass]="{ 'pending-delete-row': showRoleModified && isPendingDelete(row) }"
      *matRowDef="let row; columns: displayedColumnsRoleUsers"
      cdkDrag
    ></mat-row>
  </mat-table>
</div>
